import { authRoutes, menuRoutes, internalRoutes, rootRoute, internalProfileRoutes } from './Pages';

import * as PagePaths from '../constants/pagePath';
import { ACCESS_MATRIX, RouteGroups } from '../constants/accessMetrix';
import { hasSubscriptionPlan, isExecutivePlan, isPremiumPlan } from '../helpers/plan';
import { SubscriptionPlan } from '../helpers/enums';
import { calculateRouteAccess } from './accessCalculator';

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
  let flatRoutes = [];

  routes = routes || [];
  routes.forEach((item) => {
    flatRoutes.push(item);

    if (typeof item.children !== 'undefined') {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const allRoutes = [
  rootRoute,
  authRoutes,
  ...menuRoutes,
  ...internalRoutes,
  ...internalProfileRoutes,
];

const authProtectedRoutes = [...menuRoutes];

const allProfileRoutes = [...internalProfileRoutes];

const allFlattenRoutes = flattenRoutes(allRoutes);

const isAdminPageOnly = (path) => {
  return [PagePaths.ADMIN_INVITE_NEW_USERS].includes(path);
};

const isAllowToAccessAdminPage = (user) => {
  //return user?.id === 12 && user?.role === "Admin";
  return user?.role === 'Admin';
};

const validateUserAccess = (isAdmin, hasOrganization) => {
  return isAdmin || hasOrganization;
};

export const shouldRenderRoute = (routePath, user, systemAdminAllowed = null, forMenu = false, profileInformation = null) => {
  return calculateRouteAccess(routePath, user, { systemAdminAllowed, forMenu, profileInformation });
};

export { allRoutes, authProtectedRoutes, allFlattenRoutes, allProfileRoutes };
